import * as React from 'react';
import { calculateMetricTimeRange } from 'pages/Report/FoodWaste/components/MetricInfoIcon/util';
import { Tooltip } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { useIntl } from 'react-intl';
import { RootState } from 'redux/rootReducer';

type StateProps = ReturnType<typeof mapStateToProps>;
type MetricInfoIconProps = StateProps;

const MetricInfoIcon: React.FunctionComponent<MetricInfoIconProps> = (props) => {
  const intl = useIntl();
  const classes = useStyles(props);
  const { from, to } = calculateMetricTimeRange(props);

  return (
    <Tooltip
      title={<span>{intl.formatMessage({ id: 'report.metricFromPeriods' }, { from, to })}</span>}
    >
      <InfoIcon className={classes.infoIcon} />
    </Tooltip>
  );
};

const useStyles = makeStyles({
  infoIcon: {
    width: '20px',
    height: '20px',
    color: 'rgba(0,0,0,0.2)'
  }
});

const mapStateToProps = (state: RootState) => ({
  period: state.reportFilter.period,
  timeRange: state.reportFilter.timeRange
});

export default connect<StateProps, unknown, unknown>(mapStateToProps)(MetricInfoIcon);
